module.exports = __webpack_public_path__ + "img/banner4-01.1c19b74d.jpg";